import React, { useEffect, useState } from 'react';
import { DashboardCardItem } from '../DashboardCardItem';
import { useCallAction } from '@cobuildlab/react-simple-state';
import { fetchUserCount } from '../../../user/user-actions';

export const DashboardTotalUserItem: React.FC = () => {
  const [total, setTotal] = useState(0);
  const [callFetchUser, loading] = useCallAction(fetchUserCount, {
    onCompleted: (data) => {
      setTotal(data.count || 0);
    },
  });

  useEffect(() => {
    callFetchUser();
  }, [callFetchUser]);

  return (
    <DashboardCardItem
      title="Total usuarios registrados"
      content={total}
      loading={loading}
    />
  );
};
